/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pale_Happy_Mule_GrabInputs */

const en_pale_happy_mule_grab = /** @type {(inputs: Pale_Happy_Mule_GrabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export users`)
};

const de_pale_happy_mule_grab = /** @type {(inputs: Pale_Happy_Mule_GrabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer exportieren`)
};

/**
* | output |
* | --- |
* | "Export users" |
*
* @param {Pale_Happy_Mule_GrabInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pale_happy_mule_grab = /** @type {((inputs?: Pale_Happy_Mule_GrabInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pale_Happy_Mule_GrabInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pale_happy_mule_grab(inputs)
	return de_pale_happy_mule_grab(inputs)
});